import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useGlobalALertQuery } from './useGlobalAlertQuery';

export function GlobalAlert() {
  const { showAlert, shortMessage, showMoreModal, modalTitle, modalMessage } =
    useGlobalALertQuery();

  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  if (!showAlert) return null;

  return (
    <>
      <Alert
        severity="info"
        sx={{ width: '100%' }}
        action={
          showMoreModal ? (
            <Button color="inherit" size="small" onClick={handleOpenModal}>
              Learn more
            </Button>
          ) : null
        }
      >
        {shortMessage}
      </Alert>

      <Dialog
        open={modalOpen}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{modalTitle}</DialogTitle>
        <DialogContent>
          <Typography variant="body1">{modalMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
